import React, { useEffect } from 'react'
import { CreateProjectPageProps } from './CreateProjectPage.types'
import { inject } from 'mobx-react'
import { PROJECT_PAGE_STORE, PROJECT_STORE } from 'store'
import { observer } from 'mobx-react-lite'
import { ProjectPage } from '../ProjectPage'

const CreateProjectPageComponent = (props: CreateProjectPageProps) => {
  const {
    [PROJECT_STORE]: {
      clearParentProjectDetails,
      getProjectById
    },
    [PROJECT_PAGE_STORE]: {
      startNewProject,
      createProject,
      startNewSubProject,
      project
    },
    match: { params: { parentId } }
  } = props

  useEffect(() => {
    clearParentProjectDetails()
    if (parentId) {
      getProjectById(parentId, true, true, false)
        .then(startNewSubProject)
    } else {
      startNewProject()
    }
  }, [
    clearParentProjectDetails,
    startNewProject,
    getProjectById,
    parentId,
    startNewSubProject
  ])

  const projectPageName = project
    ? project.type
      ? `New ${project.type}`
      : undefined
    : undefined

  return (
    <ProjectPage
      projectName={projectPageName}
      submit={createProject}
    />
  )
}

const CreateProjectPage = inject(
  PROJECT_STORE, PROJECT_PAGE_STORE
)(observer(CreateProjectPageComponent))
export { CreateProjectPage }
